// Espera pelo servidor na primeira carga. No `just dev` o Vite fica pronto antes da API (as
// migrações do DBOS levam alguns segundos), e o proxy responde 502 enquanto ela não sobe.
import { useSyncExternalStore } from "react";

import { ErroApi } from "./cliente";

/** A API ainda não responde: erro de rede (o `fetch` rejeita) ou 502/503/504 do proxy. */
export function servidorIndisponivel(erro: unknown): boolean {
  if (erro instanceof ErroApi)
    return erro.status === 502 || erro.status === 503 || erro.status === 504;
  return erro instanceof TypeError;
}

let esperando = false;
const ouvintes = new Set<() => void>();

function marcar(valor: boolean) {
  if (esperando === valor) return;
  esperando = valor;
  for (const ouvinte of ouvintes) ouvinte();
}

/** Verdadeiro enquanto `comEsperaDoServidor` tenta de novo, para a tela de "Iniciando". */
export function useEsperandoServidor(): boolean {
  return useSyncExternalStore(
    (ouvinte) => {
      ouvintes.add(ouvinte);
      return () => ouvintes.delete(ouvinte);
    },
    () => esperando,
  );
}

const pausa = (ms: number) =>
  new Promise<void>((resolver) => {
    setTimeout(resolver, ms);
  });

/**
 * Chama `ler` e, se o servidor ainda não responde, tenta de novo com espera crescente (250 ms,
 * dobrando até 2 s) por até `limiteMs`. Outros erros (401, 404…) passam direto, como antes.
 */
export async function comEsperaDoServidor<T>(ler: () => Promise<T>, limiteMs = 20_000): Promise<T> {
  const inicio = Date.now();
  let espera = 250;
  try {
    for (;;) {
      try {
        return await ler();
      } catch (erro) {
        if (!servidorIndisponivel(erro) || Date.now() - inicio + espera > limiteMs) throw erro;
        marcar(true);
        await pausa(espera);
        espera = Math.min(espera * 2, 2000);
      }
    }
  } finally {
    marcar(false);
  }
}
